import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks';
import { HtmlContent } from '../../utils';
import styles from './styles/iframe_video.module.scss';

export const IframeVideo = observer(({ idForScroll }) => {
  const { loyaltyStore } = useStores();

  const { tutorialVideoIframe } = loyaltyStore;

  useEffect(() => {
    (async () => {
      await loyaltyStore.getLoyaltyConfig();
    })();
  }, []);

  return (
    <div className={styles.iframe_video} id={idForScroll}>
      <h4 className={styles.iframe_video__title}>
        <span className={styles.iframe_video__title_accent}>—</span> Видео о
        программе лояльности
      </h4>
      <div className={styles.iframe_video__video_container}>
        <HtmlContent content={tutorialVideoIframe} />
      </div>
    </div>
  );
});
